import { createSelector } from 'reselect';

const selectSubscriptionDomain = (state) => state.subscription || {};

export const getSubscriptionLoading = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.loading);

export const getSubscriptionData = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.subscriptionData);

export const getSubscriptionPlans = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.subscriptionPlans);

export const getSelectedPlan = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.selectedPlan);

export const getIsSubscribed = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.isSubscribed);

export const getSubscriptionEndDate = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.subscriptionEndDate);


export const getSubscriptionError = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.error);

// Payment flow selectors
export const getCreatingOrder = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.creatingOrder);

export const getOrderData = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.orderData);

export const getVerifyingPayment = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.verifyingPayment);

export const getPaymentVerified = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.paymentVerified);

export const getRazorpayCheckoutOpen = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.razorpayCheckoutOpen);

export const getPaymentResponse = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.paymentResponse);

export const getShowSuccessModal = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.showSuccessModal);

// Blocked Users List selectors
export const getBlockedUsersList = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.blockedUsersList);

export const getBlockedUsersListLoading = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.blockedUsersListLoading);

export const getBlockedUsersListError = () =>
  createSelector(selectSubscriptionDomain, (substate) => substate.blockedUsersListError);

